import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const Pagination = ({ pageContext }) => {
  const { previousPagePath, nextPagePath, humanPageNumber, numberOfPages, slug } = pageContext

  const getUrl = (index) => {
    if (pageContext && pageContext.type === 'tag') {
      return index === 0 ? `/blog/tag/${slug}/` : `/blog/tag/${slug}/page/${index + 1}/`
    } else if (pageContext && pageContext.type === 'author') {
      return index === 0 ? `/author/${slug}/` : `/author/${slug}/page/${index + 1}/`
    }
    return `/blog/${slug}/`
  }

  return (
    <nav className="pagination mrauto" role="navigation">
      <div>
        {previousPagePath !== null && (
          <Link to={getUrl(humanPageNumber - 2)} rel="prev" className="previouscss">
            Previous
          </Link>
        )}
      </div>
      <div className="page-selection">
        {numberOfPages > 1 && (
          <button className="pagination-location" onClick={openList}>
            Page {humanPageNumber}/{numberOfPages}
          </button>
        )}
        <div className="page-dropdown" id="page-dropdown">
          <ul className="pagination-list">
            {Array.from({ length: numberOfPages }, (_, i) => (
              <li key={`pagination-number${i + 1}`}>
                <Link to={getUrl(i)}>{i + 1}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div>
        {nextPagePath !== null && (
          <Link to={getUrl(humanPageNumber)} rel="next" className="previouscssnext">
            Next
          </Link>
        )}
      </div>
    </nav>
  )
}

Pagination.propTypes = {
  pageContext: PropTypes.object.isRequired,
}

function openList() {
  document.getElementById(`page-dropdown`).classList.add(`open-dropdown`)
}

export default Pagination
